import { UseFormReturn } from 'react-hook-form';
import { stanNotify } from '@/lib';
import type { BroadcastFormData } from '../validations/broadcastForm';

interface UseBroadcastFormHandlersProps {
    formMethods: UseFormReturn<BroadcastFormData>;
    onSaveDraft: (data: BroadcastFormData) => Promise<void>;
    onSend: (data: BroadcastFormData) => Promise<void>;
    recipientCount: number;
}

interface UseBroadcastFormHandlersReturn {
    handleSaveDraft: () => void;
    handleSend: () => void;
}

export function useBroadcastFormHandlers({
    formMethods,
    onSaveDraft,
    onSend,
    recipientCount,
}: UseBroadcastFormHandlersProps): UseBroadcastFormHandlersReturn {
    const { handleSubmit } = formMethods;

    const showValidationError = () => {
        stanNotify({
            type: 'error',
            title: 'Wait up!',
            text: 'Please provide input for each field.',
        });
    };

    const showRecipientError = () => {
        stanNotify({
            type: 'error',
            title: 'No Recipients',
            text: 'Please select at least one recipient to send the broadcast.',
        });
    };

    const handleSaveDraft = handleSubmit(async (data: BroadcastFormData) => {
        await onSaveDraft(data);
    }, showValidationError);

    const handleSend = handleSubmit(async (data: BroadcastFormData) => {
        // Additional validation for recipient count
        if (recipientCount === 0) {
            showRecipientError();
            return;
        }
        await onSend(data);
    }, showValidationError);

    return {
        handleSaveDraft,
        handleSend,
    };
}
